import { FC } from "react";

import { twMerge } from "tailwind-merge";

import {
  AGENTIC_AI_CHAT_HISTORY_EMPTY,
  AGENTIC_AI_CHAT_HISTORY_HEADING,
  type ChatHistoryEntry
} from "./constants";

type Props = {
  chats: ChatHistoryEntry[];
  activeChatId: string | null;
  onSelect: (chatId: string) => void;
};

const ChatHistoryList: FC<Props> = ({ chats, activeChatId, onSelect }) => (
  <nav
    aria-labelledby="agentic-ai-chat-history"
    className="flex min-h-0 flex-1 flex-col overflow-y-auto px-2 pb-4"
  >
    <div
      id="agentic-ai-chat-history"
      className="px-2 py-3 text-sm font-bold text-txtHeading"
    >
      {AGENTIC_AI_CHAT_HISTORY_HEADING}
    </div>

    {chats.length === 0 ? (
      <p className="px-2 text-xs leading-relaxed text-txtBody">
        {AGENTIC_AI_CHAT_HISTORY_EMPTY}
      </p>
    ) : (
      <ul className="flex flex-col">
        {chats.map(({ id, title, timeLabel }) => {
          const isActive = id === activeChatId;

          return (
            <li key={id}>
              <button
                type="button"
                onClick={() => onSelect(id)}
                aria-current={isActive ? "page" : undefined}
                className={twMerge(
                  "flex w-full flex-col gap-0.5 rounded-md px-2 py-2 text-left transition-colors hover:bg-teal-50",
                  isActive && "bg-teal-50"
                )}
              >
                <span className="truncate text-sm text-txtHeading font-semibold">
                  {title}
                </span>
                <span className="text-xs text-txtBody">{timeLabel}</span>
              </button>
            </li>
          );
        })}
      </ul>
    )}
  </nav>
);

export default ChatHistoryList;
